import { axios } from '@pukka/auth';
import { MOKA_GOAUTH_SERVICE } from '@pukka/common/constants';

const UPDATE_PAYMENT_STATUS = `${MOKA_GOAUTH_SERVICE}/billings/update_payment_status`;

type UpdatePaymentStatusRequest = {
  order_id: string; // SUB-XXXX, etc
  status_code: string; // 200, 201, etc
  transaction_status: string; // pending, capture, etc
};

async function updatePaymentStatus(params: UpdatePaymentStatusRequest) {
  return axios.get(UPDATE_PAYMENT_STATUS, { params, withCredentials: true }).then(({ data }) => data);
}

export { UPDATE_PAYMENT_STATUS, updatePaymentStatus };
